import * as types from 'types';

export function partnerVisaStatusLabel(value: string) {
  switch (value) {
    case types.PartnerVisaStatus.APPLYING_DEPENDANT:
      return 'Applying as a dependant on my visa';
    case types.PartnerVisaStatus.APPLYING_DIFFERENT:
      return 'Applying for a different type of visa';
    case types.PartnerVisaStatus.READY_TO_TRAVEL_VALID:
      return 'Ready to travel with a valid UK visa';
    case types.PartnerVisaStatus.ALREADY_IN_UK_VALID:
      return 'Already in the UK with a valid UK visa';
    default:
      return '';
  }
}
